"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1242],{

/***/ 61242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useAuthenticate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/redux/actions/auth.js
var auth = __webpack_require__(68060);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
;// CONCATENATED MODULE: ./src/hooks/useOtpLoginUtils.ts
/* eslint prefer-promise-reject-errors: 0 */ // --> ON


var OTPlessSignin = null;
var COUNTRY_CODE = {
    INDIA: "+91"
};
var CHANNELS = {
    PHONE: "PHONE",
    EMAIL: "EMAIL",
    OAUTH: "OAUTH"
};
var RESPONSE_STATUS = {
    SUCCESS: {
        CODE: 200
    },
    ERROR: {
        CODE: 400,
        MESSAGE: {
            PHONE: "Phone is required",
            EMAIL: "Email is required",
            CHANNEL: "Channel type is required",
            INVALID_CHANNEL: "Invalid channel is required"
        }
    }
};
var OTP_RESPONSE_TYPE = {
    INITIATE: "INITIATE",
    OTP_AUTO_READ: "OTP_AUTO_READ",
    VERIFY: "VERIFY",
    ONETAP: "ONETAP"
};
function loadOTPlessSdk(callback) {
    return _loadOTPlessSdk.apply(this, arguments);
}
function _loadOTPlessSdk() {
    _loadOTPlessSdk = /**
 * Creates a script element to load the OTPless SDK.
 *
 * @return {void} No return value
 */ (0,_async_to_generator/* default */.Z)(function(callback) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    if (document.getElementById("otpless-sdk") && OTPlessSignin) return resolve(OTPlessSignin);
                    var script = document.createElement("script");
                    script.src = "https://otpless.com/v3/headless.js";
                    script.id = "otpless-sdk";
                    script.setAttribute("data-appid", "INL6IR5BXCTM852URUOX");
                    script.onload = function() {
                        var OTPless = Reflect.get(window, "OTPless");
                        OTPlessSignin = new OTPless(callback);
                        resolve(OTPlessSignin);
                    };
                    document.head.appendChild(script);
                })
            ];
        });
    });
    return _loadOTPlessSdk.apply(this, arguments);
}
/**
 * Initializes the OTPless SDK and sets up a callback function.
 *
 * @param {function} callback - The callback function to be executed after successful authentication.
 * @return {void} No return value.
 */ var initOTPless = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(callback) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Loading the script if it's not already loaded
                    return [
                        4,
                        loadOTPlessSdk(callback)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function initOTPless(callback) {
        return _ref.apply(this, arguments);
    };
}();
var removeOTPLessSDK = function() {
    var ref;
    (ref = document.getElementById("otpless-sdk")) === null || ref === void 0 ? void 0 : ref.remove();
    OTPlessSignin = null;
    window.OTPless = undefined;
};
function hitOTPlessSdk(params) {
    return _hitOTPlessSdk.apply(this, arguments);
}
function _hitOTPlessSdk() {
    _hitOTPlessSdk = (0,_async_to_generator/* default */.Z)(function(params) {
        var requestType, request, channel, email, phone, channelType;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        loadOTPlessSdk()
                    ];
                case 1:
                    _state.sent();
                    requestType = params.requestType, request = params.request;
                    channel = request.channel, email = request.email, phone = request.phone, channelType = request.channelType;
                    if (channel != CHANNELS.OAUTH && channel != CHANNELS.EMAIL && channel != CHANNELS.PHONE) {
                        return [
                            2,
                            Promise.reject({
                                success: false,
                                statusCode: RESPONSE_STATUS.ERROR.CODE,
                                errorMessage: RESPONSE_STATUS.ERROR.MESSAGE.INVALID_CHANNEL + " ".concat(channel)
                            })
                        ];
                    }
                    if (channel === CHANNELS.EMAIL && !email) {
                        return [
                            2,
                            Promise.reject({
                                success: false,
                                statusCode: RESPONSE_STATUS.ERROR.CODE,
                                errorMessage: RESPONSE_STATUS.ERROR.MESSAGE.EMAIL
                            })
                        ];
                    }
                    if (channel === CHANNELS.PHONE && !phone) {
                        return [
                            2,
                            Promise.reject({
                                success: false,
                                statusCode: RESPONSE_STATUS.ERROR.CODE,
                                errorMessage: RESPONSE_STATUS.ERROR.MESSAGE.PHONE
                            })
                        ];
                    }
                    if (channel === CHANNELS.OAUTH && !channelType) {
                        return [
                            2,
                            Promise.reject({
                                success: false,
                                statusCode: RESPONSE_STATUS.ERROR.CODE,
                                errorMessage: RESPONSE_STATUS.ERROR.MESSAGE.CHANNEL
                            })
                        ];
                    }
                    return [
                        4,
                        OTPlessSignin[requestType](request)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _hitOTPlessSdk.apply(this, arguments);
}
/**
 * Authenticates the user using any authentication method available.
 * Email / Phone, OTP / Magic Link / Social Authentications
 * @param {Object} params - The parameters for primary authentication.
 * for social authentication use 'channel': 'OAUTH' and 'channelType' (eg. 'GOOGLE', 'WHATSAPP', 'GITHUB', etc)
 * for otp/magic link via email use 'channel': 'EMAIL' and 'email'
 * for otp/magic link via phone use 'channel': 'PHONE', 'phone' and 'countryCode'(optional)
 * @TODO activate your chosen authentication method from otpless Dashboard(https://otpless.com/dashboard/customer/channels) before executing this function
 * */ var initiateOTPSend = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
        var _channel, channel, _channelType, channelType, _phone, phone, _countryCode, countryCode, _email, email;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _channel = params.channel, channel = _channel === void 0 ? CHANNELS.PHONE : _channel, _channelType = params.channelType, channelType = _channelType === void 0 ? CHANNELS.PHONE : _channelType, _phone = params.phone, phone = _phone === void 0 ? "" : _phone, _countryCode = params.countryCode, countryCode = _countryCode === void 0 ? COUNTRY_CODE.INDIA : _countryCode, _email = params.email, email = _email === void 0 ? "" : _email;
                    return [
                        4,
                        hitOTPlessSdk({
                            requestType: "initiate",
                            request: {
                                channel: channel,
                                channelType: channelType,
                                phone: phone,
                                countryCode: countryCode,
                                email: email
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function initiateOTPSend(params) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Verifies the OTP (One-Time Password) for the given authentication channel.
 *
 * @param {Object} params - The parameters for verifying the OTP.
 * @param {string} [channel='PHONE'] - The authentication channel (default: 'PHONE').
 * @param {string} otp - The OTP to be verified.
 * @param {string} [countryCode='+91'] - The country code for the user's phone number (default: '+91').
 * @param {string} phone - The user's phone number.
 * @param {string} email - The user's email address.
 * @return {Promise} A promise that resolves with the result of the verification.
 */ var verifyOTPLess = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
        var _channel, channel, otp, _countryCode, countryCode, phone, email;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _channel = params.channel, channel = _channel === void 0 ? CHANNELS.PHONE : _channel, otp = params.otp, _countryCode = params.countryCode, countryCode = _countryCode === void 0 ? COUNTRY_CODE.INDIA : _countryCode, phone = params.phone, email = params.email;
                    return [
                        4,
                        hitOTPlessSdk({
                            requestType: "verify",
                            request: {
                                channel: channel,
                                phone: phone,
                                countryCode: countryCode,
                                email: email,
                                otp: otp
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function verifyOTPLess(params) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/constants/common.ts
var common = __webpack_require__(17584);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(74151);
// EXTERNAL MODULE: ./src/utils/getDecryptedContactInfo.js
var getDecryptedContactInfo = __webpack_require__(41905);
;// CONCATENATED MODULE: ./src/hooks/useAuthenticate.ts















var verifyOTPConfigs = {};
var useAuthenticate = function(timeLimit) {
    var isLoggedIn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, merchantAuthFlow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var generateOtp = function generateOtp() {
        if (!merchantAuthFlow) {
            if (isLoggedIn) {
                sendOtp();
            }
        } else {
            sendOtpMerchant();
        }
    };
    var getClevertapEventData = function getClevertapEventData(isEmailLogin, contact) {
        var ref;
        return {
            event_name: isLoggedIn ? "Cx_Delete" : "Cx_Login",
            data: (0,_define_property/* default */.Z)({
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop"
            }, isEmailLogin ? "cx_email" : "cx_phone", contact)
        };
    };
    var startTimer = function startTimer() {
        setTimeLeft(timeLimit);
        endTimer();
        timerId.current = setInterval(function() {
            return setTimeLeft(function(prevTime) {
                return --prevTime;
            });
        }, 1000);
    };
    var endTimer = function endTimer() {
        if (timerId.current) {
            clearInterval(timerId.current);
            timerId.current = null;
        }
    };
    var onOtpChange = function onOtpChange(e) {
        if (invalidOtp) {
            setInvalidOtp(false);
        }
        var value = e.target.value.trim();
        !isNaN(value) && value.length <= 4 && setOtp(value);
    };
    var onSendOtpSuccess = function onSendOtpSuccess() {
        setIsOtpSent(true);
        startTimer();
    };
    var sendOtpMerchant = function sendOtpMerchant() {
        dispatch((0,auth/* generateOTPMerchants */.ec)(authToken, onSendOtpSuccess));
    };
    var verifyMerchantActionByOtp = function verifyMerchantActionByOtp(callback) {
        var payload = {
            otp: +otp,
            phone: (0,getDecryptedContactInfo/* getDecryptedContactInfo */.D)(ownerPhone)
        };
        dispatch((0,auth/* verifyMerchantActionOtp */.v6)(payload, callback));
    };
    var authToken = (0,WidgetDndContext/* useWidgetDndContextData */.KX)().authToken;
    var ownerPhone = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2;
        return (ref = state.storeReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.owner) === null || ref2 === void 0 ? void 0 : ref2.phone;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(""), otp = ref[0], setOtp = ref[1];
    var ref1 = (0,react.useState)(timeLimit), timeLeft = ref1[0], setTimeLeft = ref1[1];
    var ref2 = (0,react.useState)(false), invalidOtp = ref2[0], setInvalidOtp = ref2[1];
    var ref3 = (0,react.useState)(false), isOtpSent = ref3[0], setIsOtpSent = ref3[1];
    var ref4 = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            userData: ((ref = state.userReducer) === null || ref === void 0 ? void 0 : ref.data) || {},
            storeInfo: state.storeReducer.store || {}
        };
    }), _userData = ref4.userData, _email = _userData.email, email = _email === void 0 ? "" : _email, _phone = _userData.phone, phone = _phone === void 0 ? "" : _phone, storeInfo = ref4.storeInfo;
    var timerId = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (merchantAuthFlow) return;
        // isUserCallbackExecuted is used as "ONETAP" event is fired multiple times in low network conditions (replicable on cart page)
        var isUserCallbackExecuted = false;
        if (common/* canUseOTPLessLogin */.Bg) {
            initOTPless(function onOTPVerificationComplete(userData) {
                var ref;
                if ((userData === null || userData === void 0 ? void 0 : userData.responseType) !== OTP_RESPONSE_TYPE.ONETAP || isUserCallbackExecuted) {
                    return;
                }
                isUserCallbackExecuted = true;
                var callback = verifyOTPConfigs.callback, isLoginAttempt = verifyOTPConfigs.isLoginAttempt, isRedirection = verifyOTPConfigs.isRedirection, isEmailLogin = verifyOTPConfigs.isEmailLogin, contact = verifyOTPConfigs.contact;
                var _obj;
                var payload = (_obj = {
                    token: userData === null || userData === void 0 ? void 0 : (ref = userData.response) === null || ref === void 0 ? void 0 : ref.token,
                    source: "cfe"
                }, (0,_define_property/* default */.Z)(_obj, isEmailLogin ? "email" : "phone", contact), (0,_define_property/* default */.Z)(_obj, "clevertapEventData", getClevertapEventData(isEmailLogin, contact)), _obj);
                dispatch((0,auth/* verifyOTP */.qD)(payload, (router_default()), isRedirection, callback, isLoginAttempt, false));
            });
            return function() {
                removeOTPLessSDK();
                verifyOTPConfigs = {};
            };
        }
    }, []);
    (0,react.useEffect)(function() {
        generateOtp();
    }, [
        isLoggedIn,
        merchantAuthFlow
    ]);
    (0,react.useEffect)(function() {
        if (!timeLeft) {
            endTimer();
        }
    }, [
        timeLeft
    ]);
    function sendOtp() {
        return _sendOtp.apply(this, arguments);
    }
    function _sendOtp() {
        _sendOtp = (0,_async_to_generator/* default */.Z)(function() {
            var contact, isEmailLogin, configArgs, data, ref, _configArgs, callback, isLoginAttempt, contact1, isEmailLogin1, isRedirection, _obj, payload;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                contact = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : email || phone || "", isEmailLogin = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : !!email, configArgs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : null;
                if (!common/* canUseOTPLessLogin */.Bg) {
                    data = {
                        email: contact,
                        store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id
                    };
                    dispatch(isEmailLogin ? (0,auth/* generateOTPforEmail */.mQ)(data, (router_default()), "web", null, onSendOtpSuccess) : (0,auth/* generateOTP */.P)(contact, (router_default()), "web", null, onSendOtpSuccess));
                } else {
                    ;
                    if (configArgs) {
                        _configArgs = (0,_sliced_to_array/* default */.Z)(configArgs, 5), callback = _configArgs[0], isLoginAttempt = _configArgs[1], contact1 = _configArgs[2], isEmailLogin1 = _configArgs[3], isRedirection = _configArgs[4];
                        verifyOTPConfigs = {
                            callback: callback,
                            isLoginAttempt: isLoginAttempt,
                            contact: contact1,
                            isEmailLogin: isEmailLogin1,
                            isRedirection: isRedirection
                        };
                    }
                    ;
                    payload = (_obj = {}, (0,_define_property/* default */.Z)(_obj, isEmailLogin ? "email" : "phone", contact), (0,_define_property/* default */.Z)(_obj, "channel", isEmailLogin ? "EMAIL" : "PHONE"), (0,_define_property/* default */.Z)(_obj, "channelType", isEmailLogin ? "EMAIL" : "PHONE"), (0,_define_property/* default */.Z)(_obj, "countryCode", isEmailLogin ? "" : COUNTRY_CODE.INDIA), _obj);
                    (ref = initiateOTPSend(payload)) === null || ref === void 0 ? void 0 : ref.then(function(data) {
                        console.log("data:  ", data);
                        if (data.responseType !== OTP_RESPONSE_TYPE.INITIATE) {
                            return;
                        }
                        if (data.statusCode !== RESPONSE_STATUS.SUCCESS.CODE) {
                            var ref;
                            (0,Toast/* toastNotifyError */.Lu)(data.errorMessage || (data === null || data === void 0 ? void 0 : (ref = data.response) === null || ref === void 0 ? void 0 : ref.errorMessage) || "Please try again!");
                            return;
                        }
                        (0,Toast/* toastNotifySuccess */.jh)("OTP sent Successfully");
                        onSendOtpSuccess();
                    }).catch(function(response) {
                        return (0,Toast/* toastNotifyError */.Lu)(response.errorMessage);
                    });
                }
                return [
                    2
                ];
            });
        });
        return _sendOtp.apply(this, arguments);
    }
    function verifyOtp(callback) {
        return _verifyOtp.apply(this, arguments);
    }
    function _verifyOtp() {
        _verifyOtp = (0,_async_to_generator/* default */.Z)(function(callback) {
            var isLoginAttempt, contact, isEmailLogin, isRedirection, _obj, payload, verifyOtpFinal, ref, _obj1, payload1;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                isLoginAttempt = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, contact = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : email || phone || "", isEmailLogin = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : !!email, isRedirection = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : false;
                if (!common/* canUseOTPLessLogin */.Bg) {
                    ;
                    payload = (_obj = {
                        otp: otp
                    }, (0,_define_property/* default */.Z)(_obj, isEmailLogin ? "email" : "phone", contact), (0,_define_property/* default */.Z)(_obj, "clevertapEventData", getClevertapEventData(isEmailLogin, contact)), _obj);
                    verifyOtpFinal = isEmailLogin ? auth/* verifyOTPforEmail */.i5 : auth/* verifyOTP */.qD;
                    dispatch(verifyOtpFinal(payload, (router_default()), isRedirection, callback, isLoginAttempt));
                } else {
                    ;
                    verifyOTPConfigs = {
                        callback: callback,
                        isLoginAttempt: isLoginAttempt,
                        contact: contact,
                        isEmailLogin: isEmailLogin,
                        isRedirection: isRedirection
                    };
                    ;
                    payload1 = (_obj1 = {
                        otp: otp
                    }, (0,_define_property/* default */.Z)(_obj1, isEmailLogin ? "email" : "phone", contact), (0,_define_property/* default */.Z)(_obj1, "channel", isEmailLogin ? "EMAIL" : "PHONE"), _obj1);
                    (ref = verifyOTPLess(payload1)) === null || ref === void 0 ? void 0 : ref.then(function(response) {
                        if ((response === null || response === void 0 ? void 0 : response.statusCode) !== RESPONSE_STATUS.SUCCESS.CODE) {
                            var ref;
                            callback === null || callback === void 0 ? void 0 : callback(false);
                            (0,Toast/* toastNotifyError */.Lu)((response === null || response === void 0 ? void 0 : response.errorMessage) || (response === null || response === void 0 ? void 0 : (ref = response.response) === null || ref === void 0 ? void 0 : ref.errorMessage) || "We ran into some issue. Please try again.");
                        }
                    }).catch(function(response) {
                        return (0,Toast/* toastNotifyError */.Lu)(response.errorMessage);
                    });
                }
                return [
                    2
                ];
            });
        });
        return _verifyOtp.apply(this, arguments);
    }
    return {
        setOtp: setOtp,
        otp: otp,
        isOtpSent: isOtpSent,
        invalidOtp: invalidOtp,
        timeLeft: timeLeft,
        generateOtp: generateOtp,
        setIsOtpSent: setIsOtpSent,
        setTimeLeft: setTimeLeft,
        setInvalidOtp: setInvalidOtp,
        onOtpChange: onOtpChange,
        sendOtp: sendOtp,
        startTimer: startTimer,
        endTimer: endTimer,
        verifyOtp: verifyOtp,
        verifyMerchantActionByOtp: verifyMerchantActionByOtp
    };
};
/* harmony default export */ var hooks_useAuthenticate = (useAuthenticate);


/***/ })

}]);